import { Popup } from "components/popups/Popup";
import Button from "components/shared/button";
import Input, { InputType } from "components/shared/inputs/input";
import { useState } from "react";
import useTranslation from "utils/hooks/useTranslation";

export const CommentPopup: React.FC<{
    closePopup: any;
    comment: string;
    maxLength: number;
    onCommentChange: (value: string) => void;
}> = ({
    closePopup,
    comment,
    maxLength,
    onCommentChange
}) => {
        const { t } = useTranslation();
        const [ tempComment, setTempComment ] = useState<string>(comment);
        return (
            <Popup title={t("QUOTE_NOTE_MODAL_TITLE")} fixSize=""
            >
                <group
                    data-direction="column"
                    data-gap="20"
                    data-space="20"
                    data-height="autofit"
                    data-length="700"
                    
                >
                    <group 
                    //data-length="autofit" data-fit="1"  data-direction="column"
                    >
                        <Input 
                            type={InputType.TextArea} 
                            value={tempComment} 
                            onChange={(e)=>setTempComment(e.target.value)} 
                            maxLength={maxLength} 
                            data-height="fit"
                            data-min-height="300"
                            dataLength="autofit"
                            //data-size="middle"
                            //inputProps={{"data-height":"auto"}}
                            
                        />
                    </group>
                    <group>
                        <text>{maxLength - tempComment?.length} {t("QUOTE_NOTE_REMAINING_CHARS")}</text>
                    </group>

                    <group data-direction="row" data-position="bottom">
                        <group data-justify="start" data-gap="20" data-length="forcefit" data-fit="1">
                            <Button
                                //accent
                                large
                                secondary
                                onClick={() => {
                                    //closePopup();
                                    onCommentChange(tempComment)
                                }}
                            >
                                {t("NAV_SAVE")}
                            </Button>
                            <Button
                                accent
                                large
                                secondary
                                onClick={() => {
                                    closePopup();
                                }}
                            >
                                {t("CANCEL")}
                            </Button>
                        </group>
                    </group>
                </group>
            </Popup>
        )
    }